// Phase 15 Plan 06 Task 1 — Notifications badge (pending friend-request count).
//
// Reads `pending_friend_request_count` from `$lobbyData`. Hidden (returns
// null) when the count is 0 to avoid clutter. Tap → routes to `/friends`.
//
// Sun-Yellow chunky-chip per UI-SPEC accent-reserved list. The chip is the
// tap target — minimum 48×48 (WCAG 2.5.5).

import { useStore } from '@nanostores/react'
import type { JSX } from 'react'
import { useIntl } from 'react-intl'

import { useRouter } from '../../router/router'
import { $lobbyData } from '../../stores/lobbyData'

export function NotificationsBadge(): JSX.Element | null {
  const lobby = useStore($lobbyData)
  const router = useRouter()
  const intl = useIntl()

  const count = lobby?.pending_friend_request_count ?? 0
  if (count === 0) return null

  const ariaLabel = intl.formatMessage(
    {
      id: 'social.lobby.notifications_aria',
      defaultMessage:
        '{count, plural, one {# pending friend request} other {# pending friend requests}}',
    },
    { count },
  )

  return (
    <button
      type="button"
      data-testid="notifications-badge"
      data-section="notifications-badge"
      aria-label={ariaLabel}
      onClick={() => router.navigate('/friends')}
      style={{
        minWidth: '48px',
        height: '48px',
        padding: '0 16px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        backgroundColor: 'var(--color-cta-primary)',
        color: 'var(--color-inkwell)',
        border: '3px solid var(--color-text-stroke)',
        borderRadius: '24px',
        fontFamily: 'Fredoka, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        cursor: 'pointer',
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      <span aria-hidden="true">{'✉'}</span>
      <span>{count}</span>
    </button>
  )
}
